import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
//primereact
import { Button } from "primereact/button";
//components
import Modal from "../../../../components/modal/Modal";
import Input from "../../../../components/input/Input";
import Toggle from "../../../../components/button/Toggle";
import NumberInput from "../../../../components/input/NumberInput";
//primereact
import { ColorPicker } from "primereact/colorpicker";
import { SelectButton } from "primereact/selectbutton";
//services
import { postStatusFunnel } from "../../../../services/Crm/Settings/Status/postStatusFunnel";
import { putStatusFunnel } from "../../../../services/Crm/Settings/Status/putStatusFunnel";
//utils
import { queryClient } from "../../../../utils/queryClient";

const ModalStatus = ({ visible, setVisible, baseData, setBaseData }) => {
  const form = useForm({ defaultValues: { time: 1 } });
  const errors = form.formState.errors;

  const options = ["Horas", "Dias"];
  const [color, setColor] = useState("000");
  const [value, setValue] = useState(options[0]);
  const [loadingButton, setLoadingButton] = useState(false);

  const { mutateAsync: postStatusFunnelFn } = useMutation({
    mutationFn: postStatusFunnel,
    onSuccess(res, _) {
      queryClient.setQueryData(["statusFunnel"], (data) => {
        return [...data, res.success];
      });
    },
  });
  
  const { mutateAsync: putStatusFunnelFn } = useMutation({
    mutationFn: putStatusFunnel,
    onSuccess(res, _) {
      queryClient.setQueryData(["statusFunnel"], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex((item) => item.id === res.success.id);
        updatedData[index] = res.success;
        return updatedData;
      });
    },
  });
  
  const onHide = () => {
    setVisible(false);
    setColor("000");
    setBaseData(null);
    form.setValue("name", "");
    form.setValue("time", 1);
  };

  const handleChangeButton = (e) => {
    if (e.value) {
      setValue(e.value);
    }
  };

  const handleEditStatus = async (data) => {
    const notification = toast.loading("Editando status...");
    setLoadingButton(true);
    const newData = {
      id: baseData.id,
      name: data.name,
      color: `#${color}`,
      interval_count: data.time,
      interval: value === options[0] ? "hour" : "day",
      register: data.register ? 1 : 0,
      served_ai: data.served_ai ? 1 : 0,
      reservation: data.reservation ? 1 : 0,
    };
    try {
      await putStatusFunnelFn(newData);
      // console.log(response);
      toast.update(notification, {
        render: "Status editado com sucesso!",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
      onHide();
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao editar status!",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
    }
    setVisible(false);
  };

  const handleAddStatus = async (data) => {
    const notification = toast.loading("Adicionando status...");
    setLoadingButton(true);
    const newItem = {
      name: data.name,
      color: `#${color}`,
      interval_count: data.time,
      interval: value === options[0] ? "hour" : "day",
    };
    // console.log(newItem);

    try {
      const response = await postStatusFunnelFn(newItem);
      // console.log(response);
      toast.update(notification, {
        render: "Status adicionado com sucesso!",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
      onHide();
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao adicionar status!",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
    }
    setVisible(false);
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    if (baseData) {
      form.setValue("name", baseData.name);
      setColor(baseData.color.replace("#", ""));
      form.setValue("time", parseFloat(baseData.interval_count));
      setValue(baseData.interval === "hour" ? options[0] : options[1]);
      form.setValue("register", baseData.register === 1 ? true : false);
      form.setValue("served_ai", baseData.served_ai === 1 ? true : false);
      form.setValue("reservation", baseData.reservation === 1 ? true : false);
    }
  }, [baseData]);

  return (
    <Modal
      dynamicTitle="Adicionar Status"
      position={"top-right"}
      visible={visible}
      dynamicWidth={window.innerWidth <= 992 ? "80vw" : "25vw"}
      onHide={onHide}
    >
      <form
        onSubmit={form.handleSubmit(
          baseData ? handleEditStatus : handleAddStatus
        )}
      >
        <div className="row">
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <ColorPicker
              format="hex"
              tooltip="Clique para escolher a cor do status"
              value={color}
              onChange={(e) => setColor(e.value)}
            />
          </div>
          <div className="col-md-10 my-4 d-flex align-items-center">
            <Input
              name="name"
              label="Nome do Status"
              className="w-100"
              //   defaultValue={baseData?.name}
              control={form.control}
              errors={errors}
            />
          </div>
          <h5 className="text-center">Tempo máximo</h5>
          <hr />
          <div className="col-md-12 d-flex justify-content-center">
            <SelectButton
              value={value}
              onChange={handleChangeButton}
              options={options}
            />
          </div>
          <div className="col-md-12 my-4 d-flex align-items-center">
            <NumberInput
              name="time"
              label="Tempo"
              className="w-100"
              errors={errors}
              prefix="Expira em "
              control={form.control}
              suffix={value === options[0] ? " horas" : " dias"}
            />
          </div>
          {baseData && (
            <>
              <div className="col-md-12 my-1 d-flex align-items-center">
                <Toggle
                  name={`register`}
                  onLabel={`Completar cadastro`}
                  offLabel={`Completar cadastro`}
                  className={"w-100"}
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              {/* <div className="col-md-12 my-1 d-flex align-items-center">
                <Toggle
                  name={`served_ai`}
                  onLabel={`Atendido por IA`}
                  offLabel={`Atendido por IA`}
                  className={"w-100"}
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div> */}
              <div className="col-md-12 my-1 d-flex align-items-center">
                <Toggle
                  name={`reservation`}
                  onLabel={`Realizar reserva`}
                  offLabel={`Realizar reserva`}
                  className={"w-100"}
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
            </>
          )}
          <div className="row justify-content-end">
            <div className="col-md-6 pt-3 justify-content-end d-flex">
              <Button
                rounded
                type="submit"
                label={baseData ? "Editar" : "Criar"}
                iconPos="right"
                loading={loadingButton}
                // onClick={() => handleNext()}
                className="p-inputtext-sm w-100"
                icon={
                  baseData
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-circle-chevron-right"
                }
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ModalStatus;
